<template>
  <section>
    <div class="container">
      <div v-if="fill_info == '' && subpage == 'open'" class="row">
        <div class="col-xs-12">
          <div class="form-title">Kitöltési útmutató</div>
          <PerfectScrollbar :options="{wheelPropagation: false, handlers:['click-rail', 'drag-thumb', 'keyboard', 'wheel', 'touch']}" style="height: 50vh; border: 1px solid #f4f4f4; padding: 20px 20px 0px 20px; margin-bottom: 20px;">
          <div class="article-text medium">
            <p>
                Tisztelt Ösztöndíjasok!
            </p>
            <p>
              Az Új Nemzeti Kiválóság Program (továbbiakban: ÚNKP) keretein belül a Pályázati Kiírásoknak megfelelően minden ösztöndíjas számára kötelező a kutatási időszaka végén (vagy a COVID vészhelyzetre való tekintettel történt Ösztöndíjszerződés módosításában általa vállalt határidőre) a pályázatában vállalt kutatásáról <span class="highlight">Szakmai Záró Beszámoló</span>t (továbbiakban: Beszámoló) és annak részeként <span class="highlight">Témavezetői Szakmai Értékelés</span>t (továbbiakban: Értékelés) benyújtania a megfelelő igazolásokkal együtt.
            </p>
            <p>
              A Beszámoló (pályázati kategóriánként) és az Értékelés sablonjait a jelen Kitöltési Útmutató elvolvasása tudják letölteni.
            </p>
            <p>
              A Beszámolót intézményünk ÚNKP bíráló bizottsága fogja értékelni Kiváló, Megfelelt és Nem megfelelt minősítéssel.
            </p>
            <p>
              Amennyiben a felsőoktatási intézmény az ösztöndíjas Beszámolóját nem fogadja el, Nem megfeleltre értékeli vagy az ösztöndíjas nem nyújtja be azt a megadott határidőig, a SZE az ösztöndíjas számára visszafizetési kötelezettséget állapít meg.
            </p>
            <p>
              A <span class="highlight">KTR felületen</span> legyenek kedvesek legkésőbb <span class="highlight">2020. július 3-án</span>, vagy a módosított Ösztöndíjszerződésben vállalt nap <u><span class="highlight">11 óráig</span> véglegesíteni</u> a Beszámolójukat, illetve ezen időpontig, <u>a KTR-es feltöltés után</u> az Igazgatási Épület (SZE Győr) 204-es irodájában (<i>előzetes időpontegyeztetés miatt legyen kedves email-t írni a <a href="mailto:tatrai.zsofia@sze.hu" title="tatrai.zsofia@sze.hu">tatrai.zsofia@sze.hu</a> email címre</i>) <span class="highlight">papír alapon</span> leadni az eredeti, aláírt <u>Beszámolót, Értékelést, Konzultációs lapot</u> és a Beszámolóhoz tartozó <u>összes mellékletet</u>. Az eredeti igazolások Önnél maradnak, ha nem kimondottan az ÚNKP Beszámolójához kérte azokat. A másolati példányra legyen kedves ráírni, hogy „Az eredetivel mindenben megegyező hiteles másolat.” és aláírni azt.
            </p>
            <p>
              Az eredeti <u>Kutatási Terv</u> a beadott pályázati anyag részét képezi, a Beszámolóhoz elegendő a másolati példány benyújtása (feltölteni a pályázati anyagából tudja az aláírt változatot).
            </p>
            <p>
              <span class="highlight">Kitöltési segédlet:</span>
            </p>
            <ul class="ordered-list with-icon" style="margin-bottom: 20px;">
              <li><i class="fa fa-angle-right"></i>A <u>Beszámoló</u>kból legyen kedves a pályázatakor megadott kategória szerinti sablont választani.</li>
              <li><i class="fa fa-angle-right"></i>Az <u>Értékelést</u> – a fejlécet kitöltve – legyen kedves eljuttatni a témavezetőjéhez és azt a Beszámoló részeként, kitöltve feltölteni a KTR rendszerbe.</li>
              <li><i class="fa fa-angle-right"></i>Az <u>1-5 pontot</u> legyen kedves röviden kifejteni, de a Beszámoló teljes terjedelme ne legyen több 3 oldalnál.</li>
              <li><i class="fa fa-angle-right"></i>A <u>2/a. pontnál</u> legyen kedves nyilatkozni, hogy az ÚNKP intézményi kerete terhére történt-e egyéni költségelszámolás (az egységesen mindenkire vonatkozó keretfelhasználást, mint az ÚNKP konferencia szervezés, Tanulmánykötet kiadás, stb. az Intézményi Záró Szakmai Beszámoló és Pénzügyi Elszámolásban (továbbiakban: Intézményi Beszámoló) az ÚNKP felelős fogja igazolni).</li>
              <li><i class="fa fa-angle-right"></i>Ha nem, kérem, ne írjon semmit a 2/a. ponthoz.</li>
              <li><i class="fa fa-angle-right"></i>Ha igen, kérem, írja le milyen jellegű volt, hogyan használta fel az ÚNKP kutatása során (1-1mondat), illetve beszerzésnél az anyagok/eszközök egyetemi leltárba kerültek vagy fogyóeszköznek minősültek.</li>
            </ul>
            <p>
              <span class="highlight">Példák 2/a ponthoz:</span>
            </p>
            <ul class="ordered-list with-icon" style="margin-bottom: 20px;">
              <li><i class="fa fa-angle-right"></i>Könyv-, adatbázis beszerzés: Saltelli, A, Chan, K., Scott, E. M.: Sensitivity Analysis, 2008, John Wiley & Sons Ltd. – kutatásom során fontos szakirodalom, egyetemi leltárba került</li>
              <li><i class="fa fa-angle-right"></i>Konferenciarészvétel: 15th Miklós Iványi International Phd&Dla Symposium, Pécs, 28-29.10.2019. – szabadon választott vállalás</li>
              <li><i class="fa fa-angle-right"></i>Eszközbeszerzés: HDD 2,5" Portable 2TB USB3.1 külső merevlemez - kutatásom során a feldolgozott szakirodalmat és az elkészített szimulációkat tároltam rajta, egyetemi leltárba került</li>
              <li><i class="fa fa-angle-right"></i>Anyagbeszerzés: csillag villáskulcs plusz egyéb laboratóriumi eszközök, melyek fogyóeszköznek minősülnek</li>
            </ul>
            <p>
              A <u>3. ponthoz</u> kerüljenek a benyújtott, de még el nem fogadott kéziratok is, amiket számszerűen a 7. pontnál is jelentessen meg. Ezeket a kéziratok kérem, NE mellékelje a Beszámolójához.
            </p>
            <p>
              A <u>6. pontban</u> az intézményen belüli kötelező vállalásokról nyilatkozik, kérem, ne javítsa a sablon szövegét. A Támogató felé az ÚNKP felelős fogja megküldeni a Tanulmánykötetet és az ÚNKP konferencia előadások elérhetőségét az Intézményi Beszámolóban.
            </p>
            <p>
              <u>7. pontnál</u> legyen kedves minden cellát kitölteni, a 0-ákat is feltüntetve.
            </p>
            <p>
              A <u>Mellékletek</u> elnevezése minden esetben a saját neve után írva a melléklet címe legyen. Pl.:<i>Vezetéknév_Anna_Kutatási_Terv</i>. A kötelező mellékletek után folytassa a számozást, illetve a Szakmai Záró Beszámoló 1-5. pontjainál is tüntesse fel a hozzá tartozó melléklet számát. A 6. ponthoz kérem, ne mellékeljen semmit, teljesítését központilag az Intézményi Szakmai és Pénzügyi Beszámolóban fogjuk igazolni. Minden más, megjelent, elfogadott cikket, konferenciaelőadást, TDK dolgozatot legyen kedves mellékelni (papír alapon kicsinyítve (1 lapon 2 oldal jelenjen meg) 2 oldalasan nyomtatva ki a cikkeket, előadásokat).
            </p>
            <p>
              Köszönettel és üdvözlettel,<br/>ÚNKP felelős
            </p>
          </div>
          </PerfectScrollbar>
          <button @click="subpage = 'data'" type="button" class="button">Tovább</button>
        </div>
      </div>
      <div v-if="fill_info == '' && subpage == 'data'" class="row">
        <div class="col-xs-12">
          <div class="form-title">Adatok</div>
        </div>
        <div class="col-sm-6">
          <inputbox id="nev" label="ÚNKP ösztöndíjas neve <span style='font-size: 10px; display: block; font-weight: 400'>(A dr-i, egyéb nevére vonatkozó előtagokat, a neve után vesszővel elválasztva tüntesse fel)</span>" name="nev" regexp_filter="[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ. ,]+" v-model="form.nev" :errors="errors"/>
        </div>
        <div class="col-sm-6">
          <inputbox id="email" label="E-mail cím <span style='font-size: 10px; display: block; font-weight: 400'>(Pályázat beadásakor megadott)</span>" name="email" v-model="form.email" :errors="errors"/>
        </div>
        <div class="clearfix"></div>
        <div class="col-sm-6">
          <inputbox id="mobilszam" label="Mobilszám" mask="+99 99 / 999 9999" regexp_filter="[0-9]+" name="mobilszam" v-model="form.mobilszam" :errors="errors"/>
        </div>
        <div class="clearfix"></div>

        <div class="col-xs-12">
          <div class="info-box download" style="margin-bottom: 5px;">
            <a target="_blank" href="assets/files/10ho_szakmai_zaro_beszamolo_alapkepzes.docx" title="Szakmai záró beszámoló alapképzés sablon letöltés">
              <span class="highlight">Szakmai záró beszámoló alapképzés sablon</span> letöltés
            </a>
          </div>
          <div class="info-box download" style="margin-bottom: 5px;">
            <a target="_blank" href="assets/files/10ho_szakmai_zaro_beszamolo_mester(osztatlan)kepzes.docx" title="Szakmai záró beszámoló mester (osztatlan) sablon letöltés">
              <span class="highlight">Szakmai záró beszámoló mester (osztatlan) sablon</span> letöltés
            </a>
          </div>
          <div class="info-box download" style="margin-bottom: 5px;">
            <a target="_blank" href="assets/files/10ho_szakmai_zaro_beszamolo_doktori_hallgato_doktorjelolt.docx" title="Szakmai záró beszámoló doktori hallgató, doktorjelölt sablon letöltés">
              <span class="highlight">Szakmai záró beszámoló doktori hallgató, doktorjelölt sablon</span> letöltés
            </a>
          </div>
          <div class="info-box download" style="margin-bottom: 5px;">
            <a target="_blank" href="assets/files/10ho_szakmai_zaro_beszamolo_bolyai.docx" title="Szakmai záró beszámoló Bólyai+ sablon">
              <span class="highlight">Szakmai záró beszámoló Bólyai+ sablon</span> letöltés
            </a>
          </div>
          <div class="info-box download" style="margin-bottom: 5px;">
            <a target="_blank" href="assets/files/10ho_szakmai_zaro_beszamolo_tehetseggel_fel.docx" title="Szakmai záró beszámoló Tehetséggel fel sablon">
              <span class="highlight">Szakmai záró beszámoló Tehetséggel fel sablon</span> letöltés
            </a>
          </div>
          <div class="info-box download">
            <a target="_blank" href="assets/files/temavezetoi_szakmai_ertekeles.docx" title="Témavezetői szakmai értékelés sablon">
              <span class="highlight">Témavezetői szakmai értékelés sablon</span> letöltés
            </a>
          </div>
        </div>

        <div class="col-xs-12">
          <UploadHandler max_uploaded_files="1" @change="(value) => { form.szakmai_zaro_beszamolo_szerkesztheto = value; }" accepted_files="application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" :errors="errors" id="szakmai_zaro_beszamolo_szerkesztheto" label="Szakmai Záró Beszámoló szerkeszthető változat <span style='font-size: 10px; display: block; font-weight: 400'>(A fájl elnevezése az ösztöndíjas előtagok nélküli neve és ÚNKP Záró Szakmai Beszámoló_szerk. legyen.)</span>" name="szakmai_zaro_beszamolo_szerkesztheto" :loaded_files="form.szakmai_zaro_beszamolo_szerkesztheto"/>
        </div>
        <div class="col-xs-12">
          <UploadHandler max_uploaded_files="1" @change="(value) => { form.szakmai_zaro_beszamolo = value; }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="szakmai_zaro_beszamolo" label="Szakmai Záró Beszámoló aláírva, szkennelve <span style='font-size: 10px; display: block; font-weight: 400'>(A fájl elnevezése az ösztöndíjas előtagok nélküli neve és ÚNKP Záró Szakmai Beszámoló legyen.)</span>" name="szakmai_zaro_beszamolo" :loaded_files="form.szakmai_zaro_beszamolo"/>
        </div>
        <div class="col-xs-12">
          <UploadHandler max_uploaded_files="1" @change="(value) => { form.temavezetoi_szakmai_ertekeles_szerkesztheto = value; }" accepted_files="application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" :errors="errors" id="temavezetoi_szakmai_ertekeles_szerkesztheto" label="Témavezetői Szakmai Értékelés szerkeszthető változat <span style='font-size: 10px; display: block; font-weight: 400'>(A fájl elnevezése az ösztöndíjas előtagok nélküli neve és ÚNKP Témavezetői Szakmai Értékelés_szerk. legyen.)</span>" name="temavezetoi_szakmai_ertekeles_szerkesztheto" :loaded_files="form.temavezetoi_szakmai_ertekeles_szerkesztheto"/>
        </div>
        <div class="col-xs-12">
          <UploadHandler max_uploaded_files="1" @change="(value) => { form.temavezetoi_szakmai_ertekeles = value; }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="temavezetoi_szakmai_ertekeles" label="Témavezetői Szakmai Értékelés aláírva, szkennelve <span style='font-size: 10px; display: block; font-weight: 400'>(A fájl elnevezése az ösztöndíjas előtagok nélküli neve és ÚNKP Témavezetői Szakmai Értékelés legyen.)</span>" name="temavezetoi_szakmai_ertekeles" :loaded_files="form.temavezetoi_szakmai_ertekeles"/>
        </div>
        <div class="col-xs-12">
          <UploadHandler max_uploaded_files="1" @change="(value) => { form.konzultacios_lap = value; }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="konzultacios_lap" label="Konzultációs lap aláírva, szkennelve <span style='font-size: 10px; display: block; font-weight: 400'>(A fájl elnevezése az ösztöndíjas előtagok nélküli neve és ÚNKP Konzultációs lap legyen.)</span>" name="konzultacios_lap" :loaded_files="form.konzultacios_lap"/>
        </div>
        <div class="col-xs-12">
          <UploadHandler max_uploaded_files="1" @change="(value) => { form.kutatasi_terv = value; }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="kutatasi_terv" label="Kutatási terv aláírva, szkennelve <span style='font-size: 10px; display: block; font-weight: 400'>(A pályázat beadásakor (alapképzés esetén szeptemberben) leadott eredeti, aláírt Kutatási Terv), (A fájl elnevezése az ösztöndíjas előtagok nélküli neve és ÚNKP Kutatási terv legyen.)</span>" name="kutatasi_terv" :loaded_files="form.kutatasi_terv"/>
        </div>
        <div class="col-xs-12">
          <UploadHandler max_uploaded_files="10" @change="(value) => { form.mellekletek = value; }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="mellekletek" label="Mellékletek <span style='font-size: 10px; display: block; font-weight: 400'>(A melléklet elnevezése, száma a Szakmai Záró Beszámoló pontjai szerint. Doktori hallgatói-, doktorjelölt kategóriánál az MTMT lista kötelező melléklet. A 6. pont teljesítését központilag az Intézményi Szakmai Beszámolóban fogjuk igazolni.)</span>" name="mellekletek" :loaded_files="form.mellekletek"/>
        </div>

        <div class="col-xs-12">
          <div v-for="(url, i) in form.melleklet_urlek" style="display: flex; align-items: center; margin-bottom: 5px;">
            <input type="text" placeholder="Külső Url (pl.: http://webcim.hu/dokumentum.pdf)" class="form-control" v-model="form.melleklet_urlek[i]"/>
            <a :href="form.melleklet_urlek[i]" target="_blank" style="margin-left: 5px;" class="button only-icon v2">
              <i class="fa fa-eye"></i>
            </a>
            <button @click="deleteUrl(i)" style="margin-left: 5px;" type="button" class="button only-icon">
              <i class="fa fa-trash-o"></i>
            </button>
          </div>
          <div style="display: flex; align-items: center; margin-bottom: 20px;">
            <input type="text" placeholder="Külső Url (pl.: http://webcim.hu/dokumentum.pdf)" class="form-control" v-model="uj_melleklet_url">
            <button @click="addUrl" style="margin-left: 5px;" type="button" class="button only-icon v2">
              <i class="fa fa-plus"></i>
            </button>
          </div>
        </div>

        <div class="col-xs-12">
          <div style="display: flex; justify-content: space-between; align-items: center">
            <button v-on:click="save(1)" :disabled="saving" type="button" class="button">Mentés</button>
            <button v-on:click="save(2)" :disabled="saving" type="button" class="button">Véglegesít</button>
          </div>
        </div>
      </div>
      <div v-if="fill_info != ''" class="row">
        <div class="col-xs-12">
          <div class="form-title">ÚNKP Szakmai Záró Beszámoló</div>
          <div v-html="fill_info"></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Vue from 'vue';
import { PerfectScrollbar } from 'vue2-perfect-scrollbar';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';

export default {
  components: {
    PerfectScrollbar
  },
  data: function() {
    return {
      saving: false,
      errors: [],
      fill_info: '',
      subpage: 'open',
      uj_melleklet_url: '',
      form: {
        tipus: 1,
        nev: '',
        email: '',
        mobilszam: '',
        szakmai_zaro_beszamolo_szerkesztheto: [],
        szakmai_zaro_beszamolo: [],
        temavezetoi_szakmai_ertekeles_szerkesztheto: [],
        temavezetoi_szakmai_ertekeles: [],
        konzultacios_lap: [],
        kutatasi_terv: [],
        mellekletek: [],
        melleklet_urlek: []
      }
    }
  },

  computed: {
  },

  watch: {
  },

  mounted: function() {
    var _this = this;

  	Vue.nextTick(function() {
      $('.subpage-head-image').height($(window).innerHeight() * .25);
      $(window).scrollTop(0);
      setHeaderDarkLine();

      $(window).resize(function() {
        setHeaderDarkLine();
      });
    });

    this.$root.ajax('form/unkp_beszamolo_ell/' + this.form.tipus, {
      success: function(response) {
        if (response.error != false) {
          _this.fill_info = response.error;
          return;
        }

        if (response.form != undefined) {
          _this.form = response.form;
        }
      }
    });
  },

  methods: {
    deleteUrl: function(i) {
      this.form.melleklet_urlek.splice(i, 1);
    },

    addUrl: function() {
      if (this.uj_melleklet_url != '') {
        this.form.melleklet_urlek.push(this.uj_melleklet_url);
        this.uj_melleklet_url = '';
      }
    },

    save: function(veglegesit) {
      var _this = this;

      this.saving = true;
      this.errors = [];

      if (this.uj_melleklet_url != '') {
        swal('Figyelem!', 'A melléklet url-jét "+" jellel adja hozzá a listához.', 'error');
        this.saving = false;
        return;
      }

      this.$root.ajax('form/unkp_beszamolo_ment', {
        method: 'POST',
        data: {
          form: JSON.stringify(this.form),
          veglegesit: veglegesit
        },
        success: function(response) {
          _this.saving = false;

          if (response.errors != undefined && response.errors.length > 0) {
            _this.errors = response.errors;

            Vue.nextTick(function() {
              $('html, body').animate({
                scrollTop: $('#' + _this.errors[0].id).offset().top - 50
              }, 500);
            })

          } else if (response.error) {
            swal('Hiba!', response.error, 'error');

          } else {
            _this.fill_info = veglegesit == 1 ? 'Ön elmentette az űrlap kitöltését. Befogadáshoz Önnek véglegesítenie kell a kitöltését. Az űrlap megtekintéséhez kattintson az alábbi <a href="javascript:void(0)" onclick="location.reload()">linkre.</a>' : 'Köszönjük, Ön sikeresen véglegesítette az űrlap kitöltését.';
          }
        }
      });
    }
  }
}
</script>


// WEBPACK FOOTER //
// unkp_beszamolo_10.vue?27935bf6